"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const rxjs_1 = require("rxjs");
const errors_1 = require("@ledgerhq/errors");
const operation_1 = require("../../operation");
const hw_app_celo_1 = require("./hw-app-celo");
const js_buildTransaction_1 = __importDefault(require("./js-buildTransaction"));
const wallet_base_1 = require("@celo/wallet-base");
const tokens_1 = require("@celo/wallet-ledger/lib/tokens");
const deviceAccess_1 = require("../../hw/deviceAccess");
const MODE_TO_TYPE = {
    send: "OUT",
    lock: "LOCK",
    unlock: "UNLOCK",
    withdraw: "WITHDRAW",
    vote: "VOTE",
    revoke: "REVOKE",
    activate: "ACTIVATE",
    register: "REGISTER",
    default: "FEE",
};
const buildOptimisticOperation = (account, transaction, fee) => {
    var _a;
    const type = ((_a = MODE_TO_TYPE[transaction.mode]) !== null && _a !== void 0 ? _a : MODE_TO_TYPE.default);
    const value = type === "OUT" || type === "LOCK"
        ? new bignumber_js_1.BigNumber(transaction.amount).plus(fee)
        : new bignumber_js_1.BigNumber(transaction.amount);
    const operation = {
        id: (0, operation_1.encodeOperationId)(account.id, "", type),
        hash: "",
        type,
        value,
        fee,
        blockHash: null,
        blockHeight: null,
        senders: [account.freshAddress],
        recipients: [transaction.recipient].filter(Boolean),
        accountId: account.id,
        date: new Date(),
        extra: {},
    };
    return operation;
};
const trimLeading0x = (input) => (input.startsWith("0x") ? input.slice(2) : input);
const parseSigningResponse = (response, chainId) => {
    // EIP155
    const sigV = parseInt(response.v, 16);
    let eip155V = chainId * 2 + 35;
    if (sigV !== eip155V && (sigV & eip155V) !== sigV) {
        eip155V += 1;
    }
    return {
        s: Buffer.from(response.s, "hex"),
        v: eip155V,
        r: Buffer.from(response.r, "hex"),
    };
};
/**
 * Sign Transaction with Ledger hardware
 */
const signOperation = ({ account, deviceId, transaction, }) => (0, deviceAccess_1.withDevice)(deviceId)(transport => new rxjs_1.Observable(o => {
    let cancelled;
    function main() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!transaction.fees) {
                throw new errors_1.FeeNotLoaded();
            }
            const celo = new hw_app_celo_1.CeloApp(transport);
            const unsignedTransaction = yield (0, js_buildTransaction_1.default)(account, transaction);
            const { chainId, to } = unsignedTransaction;
            const rlpEncodedTransaction = (0, wallet_base_1.rlpEncodedTx)(unsignedTransaction);
            const tokenInfo = (0, tokens_1.tokenInfoByAddressAndChainId)(to, chainId);
            if (tokenInfo) {
                yield celo.provideERC20TokenInformation(tokenInfo);
            }
            o.next({ type: "device-signature-requested" });
            const response = yield celo.signTransaction(account.freshAddressPath, trimLeading0x(rlpEncodedTransaction.rlpEncode));
            if (cancelled)
                return;
            const signature = parseSigningResponse(response, chainId);
            o.next({ type: "device-signature-granted" });
            const encodedTransaction = yield (0, wallet_base_1.encodeTransaction)(rlpEncodedTransaction, signature);
            const operation = buildOptimisticOperation(account, transaction, (_a = transaction.fees) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0));
            o.next({
                type: "signed",
                signedOperation: {
                    operation,
                    signature: encodedTransaction.raw,
                    expirationDate: null,
                },
            });
        });
    }
    main().then(() => o.complete(), e => o.error(e));
    return () => {
        cancelled = true;
    };
}));
exports.default = signOperation;
//# sourceMappingURL=js-signOperation.js.map